import { render, staticRenderFns } from "./EditBookingChargesAction.vue?vue&type=template&id=60790f47&scoped=true&"
import script from "./EditBookingChargesAction.vue?vue&type=script&lang=js&"
export * from "./EditBookingChargesAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60790f47",
  null
  
)

export default component.exports